import { useLanguage } from "@/contexts/LanguageContext";
import { formatUSD } from "@/lib/utils";
import type { TeamBillItem } from "@/lib/types";

// Per-model line-item table shared by AdminBills and the team's read-only
// bill view. Shows both the pre-discount list amount and the post-discount
// amount side by side, per docs/superpowers/specs/2026-07-06-billing-v2-bill-mockup.html.
export default function BillItems({ items }: { items: TeamBillItem[] }) {
  const { t } = useLanguage();

  if (items.length === 0) {
    return <div className="text-xs text-slate-500 py-3 text-center">{t("admin.bills.noItems")}</div>;
  }

  return (
    <div className="space-y-1">
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-3 text-[10px] text-slate-600 uppercase tracking-wider px-2 pb-1">
        <div>{t("admin.bills.colModel")}</div>
        <div className="text-right">{t("admin.bills.colCalls")}</div>
        <div className="text-right">{t("admin.bills.colListAmount")}</div>
        <div className="text-right">{t("admin.bills.colItemAmount")}</div>
      </div>
      {items.map((item, idx) => (
        <div
          key={idx}
          className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-3 px-2 py-1.5 text-xs text-slate-300 rounded hover:bg-white/5"
        >
          <div className="font-mono truncate">{item.science_llm_key}</div>
          <div className="text-right font-mono">{item.calls}</div>
          <div className="text-right font-mono">{formatUSD(item.list_amount)}</div>
          <div className="text-right font-mono">{formatUSD(item.amount)}</div>
        </div>
      ))}
    </div>
  );
}
